<template>
  <div v-loading="loading">
    <div class="content-list" @click="detailData.activityName ? active = false : ''">
      <div class="img_wrap g-flx" v-if="status === 2">
        <template v-if="rewardAmount">
          <img class="result_img" src="../../../../assets/image/success.png" alt="">
          <div>
            <div class="result_bold_font">恭喜您达成冲单奖励，预计获得{{detailData.rewardAmount}}元现金奖励，以实际发放为准！</div>
            <div class="result_small_font">所得奖励金将于活动结束14天后次日10点发放，即{{endDate}}上午10点发放奖励，届时请注意查收！</div>
          </div>
        </template>
        <template v-else>
          <img class="result_img" src="../../../../assets/image/fail.png" alt="">
          <div class="result_bold_font fail_result">很遗憾您冲单失败，再接再厉，欢迎再次报名！</div>
        </template>
      </div>
      <el-row>
        <el-col class="left" :span="3">活动名称：</el-col>
        <el-col class="right g-flex-start" :span="20">
          <span v-if="!active">{{ detailData.activityName }}</span>
          <el-input v-else v-model="detailData.activityName" @change="changeName" :maxlength="30" @click.stop.native size="small"></el-input>
          <img v-if="!active" src="../../../../assets/image/modify.png" @click.stop="active = true" alt="">
        </el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">创建时间：</el-col>
        <el-col class="right" :span="20">{{ detailData.createTime }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">活动油站：</el-col>
        <el-col class="right" :span="20">{{ detailData.gasName }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">活动时间：</el-col>
        <el-col class="right" :span="20">{{ detailData.startDate }} 至 {{ detailData.endDate }}</el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">报名信息：</el-col>
        <el-col class="right" :span="20">
          <div class="img_wrap">
            <div>姓名：{{ detailData.userDTO && detailData.userDTO.userName }}</div>
            <div>手机号：{{ detailData.userDTO && detailData.userDTO.mobile }}</div>
            <div>身份证号：{{ detailData.userDTO && detailData.userDTO.idCard }}</div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">活动说明：</el-col>
        <el-col class="right" :span="20">
          <div class="space_bottom"> 
            {{ detailData.explainDTO && detailData.explainDTO.totalExplain }}
          </div>
          <div class="img_wrap">
            <div class="font_b">交易订单需要满足以下条件：</div>
            <div>1.订单渠道： {{ detailData.explainDTO && detailData.explainDTO.orderChannelExplain }}</div>
            <div>2.订单用户： {{ detailData.explainDTO && detailData.explainDTO.userExplain }}</div>
            <div>3.订单油号： {{ detailData.explainDTO && detailData.explainDTO.oilExplain }}</div>
            <div>4.在活动期间或活动结束后7天之内，退款中和已退款的订单不计入至流水中；</div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">冲单奖励：</el-col>
        <el-col class="right" :span="20">
          <div class="space_bottom">活动冲单目标及奖励规则</div>
          <div>
            <el-table
              :data="tableData"
              stripe
              style="width: 100%">
              <el-table-column
                prop="level"
                label="奖励档次"
                align="center">
              </el-table-column>
              <el-table-column
                v-if="thresholdIndexType === 1"
                prop="waterOrOrderCount"
                label="交易总流水"
                align="center">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.waterOrOrderCount }} 元
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="thresholdIndexType === 2"
                prop="waterOrOrderCount"
                label="交易笔数"
                align="center">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.waterOrOrderCount }} 笔
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="calcRule"
                label="返现规则"
                align="center">
                <template slot-scope="scope">
                  <div v-if="thresholdIndexType === 1">
                    <span v-if="rewardType === 1">总流水 * {{scope.row.calcRule}}%</span>
                    <span v-if="rewardType === 2">超出{{scope.row.waterOrOrderCount}}元的部分 * {{scope.row.calcRule}}%</span>
                    <span v-if="rewardType === 3">超过{{scope.row.waterOrOrderCount}}元，奖励{{scope.row.calcRule}}元</span>
                  </div>
                  <div v-else>
                    <span v-if="rewardType === 1">每笔返现{{scope.row.calcRule}}元</span>
                    <span v-if="rewardType === 2">超出{{scope.row.waterOrOrderCount}}笔后的部分每笔返现{{scope.row.calcRule}}元</span>
                    <span v-if="rewardType === 3">超过{{scope.row.waterOrOrderCount}}笔，奖励{{scope.row.calcRule}}元</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="rewardType !== 3"
                prop="expectedMaximumReward"
                label="预计最高奖励金额">
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="left" :span="3">奖励说明：</el-col>
        <el-col class="right" :span="20">
          <div>活动结束7天后次日0点，团油平台计算油站对应的奖励金；</div>
          <div>活动结束14天后次日10点，将奖励金打入到账户中；</div>
        </el-col>
      </el-row>
    </div>

    <div class="btn_group">
      <el-button class="detail_btn" @click="cancelDialogVisible = true" v-if="activeStatus === 5">立即取消</el-button>
      <el-button class="detail_btn" @click="pushEffectAnalyze" v-if="hasFinishStatus.includes(activeStatus)">效果分析</el-button>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="cancelDialogVisible"
      width="400px"
      center
      append-to-body>
      <div class="dialog_footer dialog_content">确定立即取消该活动吗？</div>
      <div slot="footer" class="dialog_footer">
        <el-button @click="cancelDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmCancel">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>
<script>
import { changeName } from '@/api/marketShop'
import { activeDetail, cancelActive } from '@/api/runAchieve/signUp'
import dayjs from 'dayjs'

export default {
  name: 'limitShopDetail',
  props: ['detailType', 'id', 'show', 'activeStatus', 'gasStatus'],
  inject: ['resetData', 'getListData'],
  data () {
    return {
      active: false,
      detailData: {},
      regulationVos: [],
      loading: false,
      cancelDialogVisible: false,
      tableData: [],
      status: 0, // 0 待开始，1 进行中， 2 已结束
      rewardAmount: null, // 奖励金额
      thresholdIndexType: 1, // 1 交易总流水、 2 笔数
      rewardType: 1, // 1 全量  2 增量  3固定
      hasFinishStatus: [1,2,4], // 有效果分析按钮的状态
      endDate: ''
    }
  },
  methods: {
    // 初始化数据
    async initData () {
      this.loading = true
      try {
        const {code, result = {}} = await activeDetail({activeId: this.id})
        if (code !== 200) return
        this.detailData = result
        this.tableData = result.rewardList
        this.status = result.status
        this.rewardAmount = result.rewardAmount
        this.thresholdIndexType = result.thresholdIndexType
        this.rewardType = result.rewardType
        this.endDate = dayjs(result.endDate).add(15, 'day').format('MM月DD日')
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },
    // 修改活动名称
    async changeName () {
      if (!this.detailData.activityName) {
        this.$message({
          message: '请输入活动名称',
          type: 'warning'
        })
        return
      }

      try {
        const {code} = await changeName({activeName: this.detailData.activityName, activeId: this.id})
        if (code !== 200) return
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.active = false
        this.resetData(this.detailType)
        this.getListData(this.detailType)
        this.show = false
      } catch (error) {
        console.log(error)
      }
    },
    async confirmCancel () {
      try {
        const {code} = await cancelActive({activeId: this.id})
        if (code !== 200) return
        this.$message.success('取消成功')
        location.reload()
        // this.resetData(this.detailType)
        // this.getListData(this.detailType)
      } catch (error) {
        console.log(error)
      }
      this.cancelDialogVisible = false
    },
    pushEffectAnalyze () {
      this.$router.push({ path: '/promotion/dataDetail', query: { activeId: this.id, activeType: 12, gasStatus: this.gasStatus } })
    }
  },
  watch: {
    show (val) {
      val && this.initData()
      this.active = false
    }
  },
  mounted () {
    this.initData()
  }
}
</script>
<style lang="less" scoped>
  @import url('./style.less');
  .result_img {
    width: 42px;
    height: 42px;
    margin-right: 16px;
  }
  .result_bold_font {
    font-size: 14px;
    font-weight: 600;
    color: #222222;
  }
  .result_small_font {
    font-size: 12px;
    color: #666666;
    margin-top: 3px;
  }
  .space_bottom {
    margin-bottom: 13px;
  }
  .fail_result {
    height: 42px;
    line-height: 42px;
  }
  .btn_group {
    text-align: center;
    margin-top: 30px;
    .detail_btn {
      border-radius: 2px;
      border: 1px solid #4B7EFE;
      color: #4B7EFE;
    }
  }
  .dialog_footer {
    text-align: center;
  }
  .dialog_content {
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
</style>